var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from 'vue-property-decorator';
import PlainTextControl from "@/common/components/PlainTextControl.vue";
import TableRow from "@/template/components/organisationYearlyReport/TableRow.vue";
import OrganisationYearlyReportBase from '@/template/views/OrganisationYearlyReportBase';
var BalanceSheetView = /** @class */ (function (_super) {
    __extends(BalanceSheetView, _super);
    function BalanceSheetView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BalanceSheetView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.calculateAssetsTotal();
                this.calculateLiabilitiesTotal();
                this.$root.$on("numericInputValueChanged", function () {
                    _this.calculateAssetsTotal();
                    _this.calculateLiabilitiesTotal();
                });
                return [2 /*return*/];
            });
        });
    };
    BalanceSheetView.prototype.beforeDestroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$root.$off("numericInputValueChanged");
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(BalanceSheetView.prototype, "assets", {
        get: function () {
            return this.report.balanceSheet.assets;
        },
        set: function (value) {
            this.report.balanceSheet.assets = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BalanceSheetView.prototype, "liabilities", {
        get: function () {
            return this.report.balanceSheet.liabilities;
        },
        set: function (value) {
            this.report.balanceSheet.liabilities = value;
        },
        enumerable: false,
        configurable: true
    });
    BalanceSheetView.prototype.calculateAssetsTotal = function () {
        this.calculateFixedAssets();
        this.calculateCurrentAssets();
        this.assets.total = Number(this.assets.fixedAssets.value) + Number(this.assets.reserveFunds.value) + Number(this.assets.currentAssets.value);
    };
    BalanceSheetView.prototype.calculateFixedAssets = function () {
        var _this = this;
        this.assets.fixedAssets.childItems.forEach(function (x) { return _this.calculateTotalForItem(x); });
        this.calculateTotalForItem(this.assets.fixedAssets);
    };
    BalanceSheetView.prototype.calculateCurrentAssets = function () {
        var _this = this;
        this.assets.currentAssets.childItems.forEach(function (x) { return _this.calculateTotalForItem(x); });
        this.calculateTotalForItem(this.assets.currentAssets);
    };
    BalanceSheetView.prototype.calculateLiabilitiesTotal = function () {
        this.calculateCapitalAndReserves();
        this.calculateCreditors();
        this.liabilities.total = this.liabilities.capitalAndReserves.value + Number(this.liabilities.provisions.value) + this.liabilities.creditors.value;
    };
    BalanceSheetView.prototype.calculateCapitalAndReserves = function () {
        this.calculateTotalForItem(this.liabilities.capitalAndReserves);
    };
    BalanceSheetView.prototype.calculateCreditors = function () {
        var _this = this;
        this.liabilities.creditors.childItems.forEach(function (x) { return _this.calculateTotalForItem(x); });
        this.calculateTotalForItem(this.liabilities.creditors);
    };
    BalanceSheetView.prototype.calculateTotalForItem = function (item) {
        if (item.childItems) {
            item.value = item.childItems.map(function (x) { return x.value ? Number(x.value) : 0; }).reduce(function (accumulator, item) { return accumulator + item; }, 0);
        }
    };
    BalanceSheetView = __decorate([
        Component({
            name: "BalanceSheetView",
            components: {
                PlainTextControl: PlainTextControl,
                TableRow: TableRow
            }
        })
    ], BalanceSheetView);
    return BalanceSheetView;
}(OrganisationYearlyReportBase));
export default BalanceSheetView;
